import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaSquareArrowUpRight } from "react-icons/fa6";
import { faArrowRightLong } from "@fortawesome/free-solid-svg-icons";

const SectionHeader = ({ title, image, image2, title2, content, icon }) => {
  return (
    <>
      <header className="header">
        <div className="header__container">
          <div className="header__container-bg ">
            <img src={image} alt="Header background" />
          </div>
          <div className="header__content">
            <h1>{title}</h1>
          </div>
        </div>
        <div className="header__content1">
          <h4>{title2}</h4>
          <p>{content}</p>
          {icon && <FontAwesomeIcon icon={FaSquareArrowUpRight} />}
          <div className="arrow-direction-main">
            <div className="arrow-direction">
              <a href="/">
                <FontAwesomeIcon icon={faArrowRightLong} />
              </a>
            </div>
          </div>
        </div>

        <span className="header_img">
          <div className="header__top-bg ">
            <img src={image2} alt="Header background" />
          </div>
        </span>
      </header>
    </>
  );
};

export default SectionHeader;
